// hooks/useTrofeoUsuario.js
import { useState, useEffect } from 'react';
import axios from 'axios';

// Definición de la URL base de la API, usando una variable de entorno o un valor por defecto
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Definición del hook personalizado useTrofeoUsuario
const useTrofeoUsuario = () => {
    // Estado para almacenar el resumen de trofeos del usuario
    const [resumen, setResumen] = useState(null);
    // Estado para manejar el estado de carga
    const [loading, setLoading] = useState(true);
    // Estado para manejar errores
    const [error, setError] = useState(null);

    // Efecto que se ejecuta al montar el componente
    useEffect(() => {
        // Función asíncrona para obtener el resumen de trofeos
        const fetchResumen = async () => {
            try {
                // Obtener el token de autenticación del localStorage
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('No se encontró el token de autenticación');
                }
                // Realizar la petición GET a la API con el token en el header
                const response = await axios.get(`${API_BASE_URL}/api/resultados/resumen`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                // Actualizar el estado con los datos recibidos
                setResumen(response.data);
                // Marcar la carga como completada
                setLoading(false);
            } catch (error) {
                // Manejar errores: loggear en consola y actualizar el estado de error
                console.error('Error al obtener el resumen:', error);
                setError('No se pudo cargar el resumen de resultados: ' + error.message);
                // Marcar la carga como completada (aunque haya fallado)
                setLoading(false);
            }
        };

        // Ejecutar la función de obtención de datos
        fetchResumen();
    }, []); // Array de dependencias vacío, el efecto solo se ejecuta al montar el componente

    // Retornar un objeto con los estados relevantes
    return { resumen, loading, error };
};

// Exportar el hook para su uso en otros componentes
export default useTrofeoUsuario;